<script>
	import { preventNonNumericInputs } from '$lib/js/misc';
	import { createEventDispatcher } from 'svelte';

	export let type = 'button';
	export let value = '';
	export let label = '';
	export let style = '';
	export let active = false;
	export let cy = '';

	const dispatch = createEventDispatcher();
</script>

{#if type === 'button'}
	<button data-cy={cy} {style} class="button" class:active on:click={(ev) => dispatch('click')}>
		<slot />
	</button>
{:else if type === 'input'}
	<label>
		<input
			data-cy={cy}
			class="input"
			type="number"
			bind:value
			on:keydown={preventNonNumericInputs}
		/>
		{label}
	</label>
{:else if type === 'select'}
	<select data-cy={cy} {style} class="select" bind:value>
		<slot />
	</select>
{/if}

<style>
	select {
		text-align: center;
		font-family: var(--font-family);
		font-size: 15px;
		appearance: none;
		-webkit-appearance: none;
		border-radius: 0;
	}
	label {
		display: flex;
		gap: 10px;
		align-items: center;
		padding: 15px !important;
	}
	input[type='number'] {
		appearance: none;
		border: none;
		background: none;
		-moz-appearance: textfield;
		width: 22px;
		border-bottom: 1px solid var(--border-color, #000);
		text-align: center;
		color: var(--font-color);
		font-size: 16px;
	}
	input[type='number']:hover {
		border-bottom: 1px solid var(--secondary, #000);
		color: var(--font-color-secondary, #000);
	}
	input::-webkit-outer-spin-button,
	input::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}
	button,
	label,
	select {
		padding: 15px 10px;
		border: 1px solid var(--border-color, #000);
		cursor: pointer;
		background-color: transparent;
		transition: 0.2s ease;
		color: var(--font-color);
		font-family: var(--font-family);
		font-size: calc(var(--font-size) * 0.9);
	}
	button:hover,
	label:hover,
	select:hover {
		background-color: var(--secondary, #000) !important;
		color: var(--font-color-secondary, #fff) !important;
		border-color: var(--secondary, #000) !important;
	}
	button {
		text-align: center;
		display: flex;
		justify-content: center;
		align-items: center;
		gap: 10px;
	}
	button.active {
		background-color: var(--primary, #000);
		color: var(--font-color-primary, #fff);
		border-color: var(--primary, #000);
	}
	:global(button:hover .arrow::after, button:hover .arrow::before, button:hover .arrow) {
		background-color: var(--font-color-secondary) !important;
	}
	:global(button:hover path) {
		stroke: var(--font-color-secondary);
	}
</style>
